import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import swal from "sweetalert";

import commoncss from "../../myfin_v2/css/common.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";
import GroupingDrilldownTable from "./GroupingDrilldownTable"

const BalanceSheet = (props) => {
  const { bsData, selectedL1, selectedL2 } = props;
  const [activeView, setActiveView] = useState(() => {
    const saved = sessionStorage.getItem("view");
    return saved
      ? JSON.parse(saved)
      : { type: "root", level1: null, level2: null };
  });
  
  // Watch sessionStorage for view changes from child component
  useEffect(() => {
    const handleStorageChange = () => {
      const saved = sessionStorage.getItem("view");
      if (saved) {
        setActiveView(JSON.parse(saved));
      } else {
        setActiveView({ type: "root", level1: null, level2: null });
      }
    };
    
    // Listen for storage changes from the same tab
    window.addEventListener("storage", handleStorageChange);
    
    // Also check for view changes periodically during interactions
    const interval = setInterval(() => {
      const saved = sessionStorage.getItem("view");
      setActiveView(prevView => {
        const newView = saved ? JSON.parse(saved) : { type: "root", level1: null, level2: null };
        // Only update if view actually changed
        if (JSON.stringify(prevView) !== JSON.stringify(newView)) {
          return newView;
        }
        return prevView;
      });
    }, 100);
    
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
      sessionStorage.removeItem("groupingData");
      sessionStorage.removeItem("scrollPosition");
      sessionStorage.removeItem("highlightedNoteId");
    };
  }, []);
  return (
    <>
      {!bsData? (
        <div className={tablecss.tableContainer} style={{ height: "-webkit-available", overflowY: "auto" }} >
          <Spinner animation="grow" size="sm" />
          <Spinner animation="grow" style={{ margin: "1rem" }} />
          <Spinner animation="grow" size="sm" />
        </div>
      ) : (
        <>
          <>
            <div className={tablecss.tableContainer} style={{ height: "-webkit-available", overflowY: "auto", display: "flex", flexDirection: "column" }} >
              {bsData && (
                <GroupingDrilldownTable grouping={bsData}
                 view={activeView}
                 setView={setActiveView}
                  selectedL1={selectedL1}
                  selectedL2={selectedL2} 
                  setUpdateTabs={props.setUpdateTabs}/>
              )}

            </div>
          </>
        </>
      )
      }
    </>
  );
};

export default BalanceSheet;
